import { AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatLegacyAutocompleteTrigger as MatAutocompleteTrigger } from '@angular/material/legacy-autocomplete';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'xpo-select-cell-editor',
  templateUrl: './select-cell-editor.component.html',
  styleUrls: ['./select-cell-editor.component.scss'],
})
export class SelectCellEditorComponent implements ICellEditorAngularComp, AfterViewInit, OnInit {
  @ViewChild(MatAutocompleteTrigger, { read: MatAutocompleteTrigger }) matSelect: any;
  selectionControl = new UntypedFormControl();
  filteredOptions: Observable<string[]>;

  params: ICellEditorParams;
  selected: any;
  options: any[];
  registerCellChangeCallback: (params: ICellEditorParams) => any;

  constructor() {}

  ngOnInit() {
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options ? this.options.filter((option) => option.key.toLowerCase().includes(filterValue)) : [];
  }

  agInit(params: any) {
    this.params = params;
    this.options = (params as any).options;
    this.registerCellChangeCallback = (params as any).registerCellChangeCallback || (() => undefined);
    const valueToShow = this.options ? this.options.find((o) => o.value === params.value) : null;
    this.selectionControl.setValue(valueToShow?.key ?? params.value ?? '');
    this.filteredOptions = this.selectionControl.valueChanges.pipe(
      startWith(this.selectionControl.value ?? ''),
      map((value) => this._filter(typeof value === 'string' ? value : ''))
    );
  }

  onEventSelection() {
    this.params.stopEditing();
    this.registerCellChangeCallback(this.params);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.matSelect.openPanel();
      document.getElementById('matSelect').focus();
    });
  }

  getValue(): any {
    const key = this.selectionControl.value;
    const matched = this.options ? this.options.find((o) => o.key === key) : null;
    return matched ? matched.value : key;
  }
}
